import React, { useState } from "react";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { css } from "react-emotion";

const moveBack50 = css`
  transform: translateX(-25px);
`;
const rotate90 = css`
  transform: translateX(-25px) rotate(90deg);
  margin-left: 0;
  margin-right: 20px;
`;

const faqWrapper = css`
  padding: 7px 0px;
  :not(:first-child) {
    border-top: 1px solid rgb(218, 218, 218);
  }
`;

const faqRow = css`
  width: 100%;
  color: black;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  text-align: left;
  margin: 12px 0px;
`;

const faqCol = css`
  font-size: 1em;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  flex-basis: 0;
  color: black;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  line-height: 35px;
  transition: all 1000ms ease;
  -moz-transition: all 1000ms ease;
  -ms-transition: all 1000ms ease;
  -o-transition: all 1000ms ease;
  -webkit-transition: all 1000ms ease;
`;

const answerStyle = css`
  padding: 15px;
  margin-bottom: 15px;
`;

function FAQObject({ qaObj, ...props }) {
  const [showAnswer, setShowAnswer] = useState(false);
  const [hovered, setHovered] = useState(false);

  const question = qaObj ? qaObj.question : "";
  const answer = qaObj ? qaObj.answer : "";

  const toggleDetails = () => {
    setShowAnswer(!showAnswer);
  };

  const getCaretClass = () => {
    if (hovered && !showAnswer) {
      return moveBack50;
    } else if (showAnswer) {
      return rotate90;
    }
    return null;
  };

  return (
    <div className={faqWrapper}>
      <div
        className={faqRow}
        onClick={toggleDetails}
        onMouseOver={() => {
          setHovered(true);
        }}
        onMouseOut={() => {
          setHovered(false);
        }}
      >
        <div className={faqCol}>
          <div
            style={{
              fontSize: "0.9375rem",
              lineHeight: "normal",
            }}
          >
            <p>{question ? question : null}</p>
          </div>
        </div>
        <div
          style={{
            flex: "0 0 auto",
            width: "auto",
            maxWidth: "100%",
            position: "relative",
            paddingLeft: "15px",
          }}
        >
          {" "}
          <ListItemIcon
            style={{
              color: "#89d2d3",
            }}
          >
            <span
              style={{
                fontSize: "1.5rem",
                display: "block",
                transition: "all 0.2s ease-in-out",
                marginLeft: "20px",
              }}
              className={getCaretClass()}
            >
              <FontAwesomeIcon icon="angle-right" />
            </span>
          </ListItemIcon>
        </div>
      </div>
      <div
        className={faqCol}
        style={{
          textAlign: "left",
          fontSize: "0.9375rem",
          opacity: showAnswer ? "100%" : "0%",
          height: showAnswer ? "min-content" : "0%",
        }}
      >
        {showAnswer ? (
          <div>
            <p className={answerStyle}>{answer}</p>{" "}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default FAQObject;
